<ng-container *ngIf="!!flightTrackerDirectResults">
  <div
    tabindex="0"
    #flightResultsContainer
    class="bg-black-05 pt7-ns pv4"
    *ngIf="!flightTrackerError"
  >
    <!--Direct Flight results-->
    <div
      *ngIf="
        !!flightTrackerDirectResults && flightTrackerDirectResults.length > 0
      "
      class="page-margin flex flex-column"
    >
      <!-- heading  -->
      <div
        class="flex justify-between center-l center-m col-10-l col-10-m"
        [ngClass]="{
          'items-top': isWrappedDirect,
          'items-baseline': !isWrappedDirect
        }"
      >
        <h2
          *ngIf="
            flightTrackerDirectResults.length >= 1 ||
            flightTrackerConnectingResults.length > 0
          "
          class="core-blue l-heading"
        >
          {{ (flightTrackerText$ | async)?.directFlights }} ({{
            flightTrackerDirectResults.length
          }})
        </h2>
        <div class="z-1 dn db-ns ml3">
          <div
            class="flex-ns flex-wrap-ns justify-end-ns"
            jbWrapDetector
            (wrapDetected)="handleWrapDetection($event, 'direct')"
          >
            <span class="s-body" [ngClass]="{ mb1: isWrappedDirect }"
              >{{ (flightTrackerText$ | async)?.lastUpdated }}
              {{ currentTime | date: 'h:mma' | lowercase }}</span
            >
            <jb-action
              class="pl2"
              id="action-button-icon"
              actionIcon="reload"
              (click)="refreshStatus.emit()"
            >
              {{ (flightTrackerText$ | async)?.refreshStatus }}
            </jb-action>
          </div>
        </div>
      </div>
      <!-- end of heading -->
      <span
        *ngIf="
          flightTrackerDirectResults.length === 1 &&
          flightTrackerConnectingResults.length === 0
        "
        class="fl"
      ></span>
      <jb-flight-tracker-results-direct
        tabindex="-1"
        [departureDate]="departureDate"
        [flightTrackerCopy]="flightTrackerText$ | async"
        [flightTrackerDirectResults]="flightTrackerDirectResults"
      >
      </jb-flight-tracker-results-direct>
    </div>
    <!--Connecting Flight results-->
    <div
      *ngIf="
        !!flightTrackerConnectingResults &&
        flightTrackerConnectingResults.length > 0
      "
      class="page-margin flex flex-column"
    >
      <div
        class="flex justify-between center-l center-m col-10-l col-10-m"
        [ngClass]="{
          'items-top': isWrappedConnecting,
          'items-baseline': !isWrappedConnecting
        }"
      >
        <h2
          class="core-blue l-heading nowrap-ns"
          [ngClass]="{
            'pt4 pt7-ns mb3': flightTrackerDirectResults.length > 0
          }"
        >
          {{ (flightTrackerText$ | async)?.connectingFlights }} ({{
            flightTrackerConnectingResults.length
          }})
        </h2>
        <div
          class="z-1 dn db-ns ml3"
          [ngClass]="{
            'pt7-ns': flightTrackerDirectResults.length > 0
          }"
        >
          <div
            class="flex-ns flex-wrap-ns justify-end-ns"
            jbWrapDetector
            (wrapDetected)="handleWrapDetection($event, 'connecting')"
          >
            <span class="s-body" [ngClass]="{ mb1: isWrappedConnecting }"
              >{{ (flightTrackerText$ | async)?.lastUpdated }}
              {{ currentTime | date: 'h:mma' | lowercase }}</span
            >
            <jb-action
              class="pl2"
              id="action-button-icon"
              actionIcon="reload"
              (click)="refreshStatus.emit()"
            >
              {{ (flightTrackerText$ | async)?.refreshStatus }}
            </jb-action>
          </div>
        </div>
      </div>

      <jb-flight-tracker-results-connecting
        [departureDate]="departureDate"
        [flightTrackerCopy]="flightTrackerText$ | async"
        [flightTrackerConnectingResults]="flightTrackerConnectingResults"
      >
      </jb-flight-tracker-results-connecting>
    </div>
  </div>
  <div tabindex="-1" #serverError *ngIf="flightTrackerError">
    <ng-container
      *ngIf="flightTrackerError.status !== 404"
      [ngTemplateOutlet]="serviceErrorTpl"
    >
    </ng-container>

    <ng-container
      *ngIf="flightTrackerError.status === 404"
      [ngTemplateOutlet]="noResultsTpl"
    >
    </ng-container>
  </div>
</ng-container>

<div
  tabindex="-1"
  #serverErrorOffline
  *ngIf="flightTrackerDirectResults === undefined"
>
  <ng-container [ngTemplateOutlet]="serviceErrorTpl"></ng-container>
</div>
<jb-flight-tracker-mobile-alert-label
  [lowerLabel]="true"
  [mobileAlertCopy]="(flightTrackerText$ | async)?.mobileAlertLabel"
  (headerHidden)="displayHeader($event)"
></jb-flight-tracker-mobile-alert-label>

<ng-template #serviceErrorTpl>
  <jb-message-block
    [img]="{ src: serviceError.src, alt: serviceError.alt }"
    [title]="serviceError.title"
    [body]="serviceError.subtitle"
    [link]="{
      href: '/contact-us',
      text: (flightTrackerText$ | async)?.contactUs
    }"
    class="service-error-block"
  >
  </jb-message-block>
</ng-template>

<ng-template #noResultsTpl>
  <jb-message-block
    [img]="{ src: noResultsError.src, alt: noResultsError.alt }"
    [title]="noResultsError.title"
    [body]="noResultsError.subtitle"
    class="no-results-error-block pv5"
  >
  </jb-message-block>
</ng-template>
